import React from 'react';
import type { GetStaticProps } from 'next';

import { Navigation } from '@/components/Navigation';
import { LearnArticlesContent } from '@/components/learn/LearnArticlesContent';
import { Mode } from '@/constants/Mode';
import { Footer } from '@/components/Footer';
import type { NextPageWithLayout } from '../../types/layoutExtensions';
import { SEO } from '../../components/SEO';

import { LearnArticleListQuery } from '../../queries/LearnArticleListQuery';
import { fetchGraphQL } from '../../queries/fetchGraphQL';

const LearnArticles: NextPageWithLayout = cachedData => (
  <>
    <Navigation mode={Mode.LIGHT} />
    <LearnArticlesContent data={cachedData} />
  </>
);

LearnArticles.getLayout = (page: React.ReactNode) => (
  <>
    <SEO
      seoTitle="Learn More About Home Loans | Athena"
      seoDescription="Use our online help guides to learn about home loans, refinancing, interest rates and more. Click here to get expert advice!"
      fullPath="/learn"
    />
    <div className="page">{page}</div>
    <Footer />
  </>
);

export const getStaticProps: GetStaticProps = async () => {
  const { data }: any = await fetchGraphQL(LearnArticleListQuery, false);
  return {
    props: {
      cachedData: data?.publicSitePagesCollection?.items ?? null,
    },
  };
};

export default LearnArticles;
